module.exports = __webpack_public_path__ + "static_pc/img/14.9a653747.png";